/**
 * The group the page on screen belongs to (`current`, which the rail marks) and the group the rail
 * opens on (`open`). Djinn is in no group: on its page no group is marked, so the Djinn row is the
 * only one that says where you are, and Operate is simply left open as on any page outside a group.
 */
export function railGroupOf(
  groups: readonly { title: string; items: readonly { to: string }[] }[],
  pathname: string,
  projectId: string,
  envId: string | undefined,
): { open: string; current: string | null } {
  const current =
    groups.find((group) =>
      group.items.some((item) => {
        const path = item.to.replace("$projectId", projectId).replace("$envId", envId ?? "");
        return (
          pathname === path ||
          (item.to !== "/projects/$projectId" && pathname.startsWith(`${path}/`))
        );
      }),
    )?.title ?? null;
  const djinn = `/projects/${projectId}/djinn`;
  const onDjinn = pathname === djinn || pathname.startsWith(`${djinn}/`);
  return { open: current ?? "Operate", current: onDjinn ? null : (current ?? "Operate") };
}
